import { OMath } from "@olga-food/schemas/lib/classes/tools/OMath";

export class NetLogicCombo {
  item = null;

  constructor(item) {
    this.item = item;
  }

  static isCombo(item) {
    return isCombo(item);
  }

  mountCondiment(condiment) {
    const sku = getSku(condiment);

    return {
      index: 0,
      id: sku,
      name: condiment.name,
      externalCode: sku,
      quantity: condiment.quantity || 1,
      price: condiment.price,
      totalPrice: +OMath.times(condiment.quantity || 1, condiment.price || 0),
      discount: 0,
      discountCode: 0,
      discountInfo: "",
      addition: 0,
      subItems: [],
      subItemsPrice: 0,
      observations: condiment.observation || "",
    };
  }

  mountSide(side, options = []) {
    const sku = getSku(side);

    const price =
      side.sizes && side.sizes[0] ? side.sizes[0].price : side.price || 0;

    const condiments = [];
    while (options.length > 0) {
      const option = options.splice(0, 1)[0];
      if (isCondiment(option)) {
        condiments.push(this.mountCondiment(option, options));
      } else {
        options.unshift(option);
        break;
      }
    }

    return {
      index: 0,
      id: sku,
      externalId: sku,
      externalCode: sku,
      name: side.name,
      quantity: side.quantity || 1,
      price: price,
      totalPrice: +OMath.times(side.quantity || 1, price),
      discount: 0,
      discountCode: 0,
      discountInfo: "",
      addition: 0,
      subItemsPrice: 0,
      subItems: condiments,
      observations: side.observation || "",
    };
  }

  mountItem(item, options = []) {
    const sku = getSku(item);

    const price =
      item.sizes && item.sizes[0] ? item.sizes[0].price : item.price || 0;

    const condiments = [];
    while (options.length > 0) {
      const option = options.splice(0, 1)[0];
      if (isCondiment(option)) {
        condiments.push(this.mountCondiment(option));
      } else {
        options.unshift(option);
        break;
      }
    }

    return {
      index: 0,
      id: sku,
      externalId: sku,
      externalCode: sku,
      name: item.name,
      quantity: item.quantity || 1,
      price: price,
      totalPrice: +OMath.times(item.quantity || 1, price),
      discount: 0,
      discountCode: 0,
      discountInfo: "",
      addition: 0,
      subItemsPrice: 0,
      subItems: condiments,
      observations: item.observation || "",
    };
  }

  mountProduct(product, options = []) {
    const sku = getSku(product);

    const price =
      product.sizes && product.sizes[0]
        ? product.sizes[0].price
        : product.price || 0;
    const condiments = [];

    while (options.length > 0) {
      const option = options.splice(0, 1)[0];
      if (isCondiment(option)) {
        condiments.push(this.mountCondiment(option));
      } else {
        options.unshift(option);
        break;
      }
    }

    return {
      index: 0,
      id: sku,
      externalId: sku,
      externalCode: sku,
      name: product.name,
      quantity: product.quantity || 1,
      price: price,
      totalPrice: +OMath.times(product.quantity || 1, price),
      discount: 0,
      discountCode: 0,
      discountInfo: "",
      addition: 0,
      subItemsPrice: 0,
      subItems: condiments,
      observations: product.observation || "",
    };
  }

  mountCombo(item, options = []) {
    const sku = getSku(item);

    const combo_items = [];

    while (options.length > 0) {
      const option = options.splice(0, 1)[0];
      if (isProduct(option)) {
        combo_items.push(this.mountProduct(option, options));
      } else if (isItem(option)) {
        combo_items.push(this.mountItem(option, options));
      } else if (isSide(option)) {
        combo_items.push(this.mountSide(option, options));
      } else {
        options.unshift(option);
        break;
      }
    }

    return {
      comboId: sku,
      comboItems: combo_items,
    };
  }

  /**
   *
   * @returns {Array<Object>}
   */
  export() {
    if (!isCombo(this.item)) {
      return [];
    }

    const options = [];

    for (const question of this.item.items) {
      for (const option of question.items) {
        if (option.selected) {
          options.push(option);
        }
      }
    }

    options.unshift(this.item);
    const items = [];
    while (options.length > 0) {
      const option = options.splice(0, 1)[0];
      if (!isCombo(option)) {
        continue;
      }
      items.push(this.mountCombo(option, options));
    }

    const final = [];
    for (let i = 0; i < this.item.quantity; i++) {
      final.push(
        ...items.map((i) => {
          i.quantity = 1;
          return i;
        })
      );
    }

    return final;
  }
}

const getSku = (item) => {
  if (item.sizes && item.sizes.length > 0) {
    const size = item.sizes[0];
    if (size && size.sku) {
      return size.sku;
    }
  }
  return item.sku || ``;
};

const isCombo = (item) => {
  return getSku(item).startsWith("B");
};

const isProduct = (item) => {
  return getSku(item).startsWith("P");
};

const isSide = (item) => {
  return getSku(item).startsWith("D");
};

const isItem = (item) => {
  return getSku(item).startsWith("I");
};

const isCondiment = (item) => {
  return getSku(item).startsWith("C");
};
